var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24543 7.11171C0.646286 7.71086 0 10.8883 0 11.1429C0 11.5894 0.348 12 0.857143 12C1.11171 12 4.28914 11.3537 4.88829 10.7546L9.79286 5.85L6.15 2.20714L1.24543 7.11171ZM9.42857 0C8.91257 0 8.18657 0.170571 7.59343 0.763714L7.35 1.00714L10.9929 4.65L11.2363 4.40657C11.7823 3.86057 12 3.16714 12 2.57143C12 1.15114 10.848 0 9.42857 0Z",
    fill: "#503EB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPurple);
export default __webpack_public_path__ + "static/media/edit-purple.01063f1db2863ffa1fc13e4ede5baf2f.svg";
export { ForwardRef as ReactComponent };